<template>
  <div>
    <el-dialog
      title="İcra Dosyası"
      :visible.sync="ModalOlayi"
      center
      width="50%">
      <Yukleniyor :data="lo"></Yukleniyor>
      <a @click="ModalKapat" class="ModalKapat"><i class="el-icon-close"></i></a>
      <el-form :model="Form" @submit.prevent.native="Submit" :rules="FormHata" ref="Form">
        <el-alert
          v-if="Aidatim"
          title="Aidatım ile Tık Diye Avukatlık Hizmeti"
          type="info"
          :closable="false"
          description="Hatalı işlem olmaması için Avukatlık birimi bilgisi olmadan dosyayı güncellemeyiniz."
        >
        </el-alert>
        <el-collapse accordion>
          <el-collapse-item name="1">
            <template slot="title">
              <el-tooltip class="item" effect="dark"
                          content="Kendinize ait avukat biriminiz var ise avukat tarafından doldurulacaktır."
                          placement="top">
                <i class="el-icon-info text-primary cursor-pointer"></i>
              </el-tooltip>
              Avukat Detayları
            </template>
            <el-row :gutter="24">

              <el-col :span="12">
                <el-form-item label="Anlaşmalı Avukat" class="Tooltip" prop="Avukat_id">
                  <el-tooltip class="item" effect="dark"
                              content="İcra menüsünden Avukat ekleyebilirsiniz."
                              placement="top">
                    <i class="el-icon-info text-primary cursor-pointer"></i>
                  </el-tooltip>
                  <el-select v-model="Form.Avukat_id" :disabled="Aidatim"
                             placeholder="Aidatım ile hızlıca icraya verebilirsiniz."
                             @change="AvukatSecimi" filterable clearable>
                    <el-option
                      v-if="item.bBilgi!='Aidatım'"
                      v-for="item in Avukatlar"
                      :key="item.id"
                      :label="item.Unvan"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="Dosya No" prop="dNo">
                  <el-input v-model="Form.dNo"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="İcra Tarih" prop="iTarih">
                  <el-date-picker
                    v-model="Form.iTarih"
                    type="date"
                    placeholder=""
                    format="dd.MM.yyyy">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <small>Aidatım avukatlık takip hizmetini kullanmak için Avukat seçimi yapmayınız.</small>
              </el-col>
            </el-row>
          </el-collapse-item>
        </el-collapse>
        <el-collapse accordion v-if="!Bilgi">
          <el-collapse-item name="1">
            <template slot="title">
              <el-tooltip class="item" effect="dark" content="Avukat Vekalet ücretini kişiye borçlandır"
                          placement="top">
                <i class="el-icon-info text-primary cursor-pointer"></i>
              </el-tooltip>
              Kişi Borçlandır
            </template>
            <el-row :gutter="24">
              <el-col :span="6">
                <el-form-item label="Vekalet Ücreti" prop="Tutar">
                  <el-input v-model="Form.Tutar"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="Kategori" prop="Kategori_id">
                  <el-cascader
                    :options="Kategoriler"
                    v-model="Form.Kategori_id"
                    collapse-tags
                    filterable></el-cascader>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="Açıklama" prop="Aciklama">
                  <el-input v-model="Form.Aciklama"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <div v-if="Form.Tutar && Form.iTarih && Form.Kategori_id" class="alert alert-success">{{ Form.Tutar }}
                  TL,
                  İcra Tarih ve Kategori baz alınarak Kişiye borç işlenecektir.
                </div>
              </el-col>
            </el-row>
          </el-collapse-item>
        </el-collapse>
      </el-form>
      <div class="icraSecim mt-4" v-if="data">
        <el-row :gutter="24">
          <el-col :span="6">
            <mWidget
              :data="{isim: 'Seçilen Dosya Sayısı', sayi: data.length, icon: '', renk: 'ins1 m-widget-mini'}"></mWidget>
          </el-col>
          <el-col :span="6">
            <mWidget
              :data="{isim: 'Seçilen Anapara', sayi: AltToplam.ToplamTutar, icon: '', renk: 'ins2 m-widget-mini'}"></mWidget>
          </el-col>
          <el-col :span="6">
            <mWidget
              :data="{isim: 'Seçilen Zam', sayi: AltToplam.ToplamZam, icon: '', renk: 'ins3 m-widget-mini'}"></mWidget>
          </el-col>
          <el-col :span="6">
            <mWidget
              :data="{isim: 'Seçilen Ödenecek', sayi: AltToplam.ToplamOdenecek, icon: '', renk: 'ins4 m-widget-mini'}"></mWidget>
          </el-col>
        </el-row>
      </div>
      <hr>
      <table class="table table-sm table-hover" v-if="data">
        <thead>
        <tr>
          <th>Borçlanma Tarihi</th>
          <th>Son Ödeme Tarihi</th>
          <th>Kategori</th>
          <th>Zam</th>
          <th>Tutar</th>
          <th>Zam Tutar</th>
          <th>Ödenecek</th>
          <th v-if="Bilgi"></th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(Borc,index) in data">
          <td>{{ Borc.tTarihi }}</td>
          <td>{{ Borc.sTarihi }}</td>
          <td>{{ Borc.Kategori }}</td>
          <td>{{ Borc.Zam }}</td>
          <td>{{ Borc.Tutar }}</td>
          <td>{{ Borc.ZamTutar }}</td>
          <td>{{ Borc.Odenecek }}</td>
          <td v-if="Bilgi"><a @click="Cikar(index)">
            <el-tooltip class="item" effect="dark"
                        content="Tahakkuku Dosyadan Çıkar"
                        placement="top">
              <i class="el-icon-remove text-danger cursor-pointer"></i>
            </el-tooltip>
          </a></td>
        </tr>
        </tbody>
      </table>

      <div slot="footer" v-if="!lo" class="dialog-footer">
        <el-button-group>
          <el-button :type="Bilgi?'primary':ButonRenk" size="small" @click="Submit()"
                     :icon="Bilgi?'el-icon-check':'el-icon-lock'">{{ ButonAdi }}
          </el-button>
          <el-button v-if="Bilgi && this.$store.getters.Yetki.IcraTahsilat>0" type="success" size="small"
                     @click="OdemeModal=true"
          >Ödeme Al
          </el-button>
          <el-button v-if="Bilgi" size="small" type="danger" @click="SilOnay">Sil</el-button>
        </el-button-group>
      </div>
      <IcraOdemeAl v-if="OdemeModal" :data="Bilgi" :Bina_id="Bina_id" @Modal="OdemeModal=false"></IcraOdemeAl>
      <div v-if="Gecmis">
        <el-divider content-position="left">Dosya Tahakkuk Geçmişi</el-divider>
        <el-collapse accordion>
          <el-collapse-item v-for="(g,i) in Gecmis" :title="g.tarih+' Tarihli İşlem'" :name="i">
            <table class="table table-sm table-hover">
              <thead>
              <tr>
                <th>Borçlanma Tarihi</th>
                <th>Son Ödeme Tarihi</th>
                <th>Kategori</th>
                <th>Zam</th>
                <th>Tutar</th>
                <th>Zam Tutar</th>
                <th>Ödenecek</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="Tahakkuk in g.Tahakkuklar">
                <td>{{ Tahakkuk.tTarihi }}</td>
                <td>{{ Tahakkuk.sTarihi }}</td>
                <td>{{ Tahakkuk.Kategori }}</td>
                <td>{{ Tahakkuk.Zam }}</td>
                <td>{{ Tahakkuk.Tutar }}</td>
                <td>{{ Tahakkuk.ZamTutar }}</td>
                <td>{{ Tahakkuk.Odenecek }}</td>
              </tr>
              </tbody>
            </table>
          </el-collapse-item>
        </el-collapse>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import Yukleniyor from "../../Doc/Yukleniyor";
import IcraOdemeAl from "./IcraOdemeAl";
import MWidget from "../Genel/mWidget";

export default {
  components: {MWidget, Yukleniyor, IcraOdemeAl},
  props: ['ModalOlayi', 'data', 'Bilgi', 'Bina_id'],
  data() {
    return {
      lo: false,
      OdemeModal: false,
      Aidatim: false,
      Form: {
        Avukat_id: null,
        Kategori_id: null,
        Tutar: null,
        Aciklama: null,
        iTarih: null,
        dNo: null,
        id: null
      },
      AltToplam: {
        ToplamTutar: null,
        ToplamZam: null,
        ToplamOdenecek: null
      },
      Avukatlar: null,
      Kategoriler: null,
      Gecmis: null,
      ButonAdi: 'Aidatım ile Dosya Oluştur',
      ButonRenk: 'success',
      FormHata: {
        iTarih: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
      },
    }
  },
  methods: {
    SilOnay() {
      this.$confirm(this.$t('eGenel.1'), this.$t('eGenel.7'), {
        confirmButtonText: this.$t('eGenel.2'),
        cancelButtonText: this.$t('eGenel.3'),
        type: 'warning'
      }).then(() => {
        this.Sil()
      }).catch(() => {
        this.$message.info(this.$t('eGenel.8'));
      });
    },
    Sil() {
      this.$store.dispatch("Delete", {path: 'icra/dosya/' + this.Bilgi.id})
        .then(response => {
          if (response.Durum == "OK") {
            this.$message.success(response.Mesaj);
            this.$emit('ModalOlayi', false);
          } else {
            this.$message.warning(response.Mesaj);
            this.hata = response.Hata;
          }
        })

    },
    AvukatSecimi() {
      if (!this.Form.Avukat_id) {
        this.ButonAdi = 'Aidatım ile Dosya Oluştur';
        this.ButonRenk = 'success';
      } else {
        this.ButonAdi = 'Kendi Avukatım ile Dosya Oluştur';
        this.ButonRenk = 'danger';
      }
    },
    Cikar(index) {
      this.data.splice(index, 1);
      this.reHesap();
    },
    reHesap() {
      if (this.data) {
        this.AltToplam.ToplamTutar = this.data.reduce((acc, item) => acc + Number(item.Tutar), 0).toFixed(2);
        this.AltToplam.ToplamZam = this.data.reduce((acc, item) => acc + Number(item.ZamTutar), 0).toFixed(2);
        this.AltToplam.ToplamOdenecek = (Number(this.AltToplam.ToplamTutar) + Number(this.AltToplam.ToplamZam)).toFixed(2);
      }
    },
    SayfaYukle() {
      this.Gecmis = null;
      this.lo = true;
      if (this.Bilgi) {
        this.Form.Avukat_id = this.Bilgi.Avukat_id;
        this.Form.dNo = this.Bilgi.dNo;
        this.Form.id = this.Bilgi.id;
        this.Form.iTarih = this.Bilgi.iTarih;
        this.ButonAdi = 'Dosya Güncelle';

        this.$store.dispatch("Get", {path: 'icra/dosya/gecmis/' + this.Bilgi.id})
          .then(response => {
            this.lo = false;
            if (response.Durum === 'OK') {
              this.Gecmis = response.Liste
            } else {
              this.$message.error(response.Mesaj);
              this.hata = response.Hata;
            }
          });
      }
      this.reHesap();
      this.$store.dispatch("Get", {path: 'muhasebe/cari/a/'})
        .then(response => {
          if (response.Durum === 'OK') {
            this.Avukatlar = response.Liste
          } else {
            this.$message.error(response.Mesaj);
            this.hata = response.Hata;
          }
        });
      if (!this.Bilgi) {
        this.$store.dispatch("Get", {path: 'muhasebe/kategori'})
          .then(response => {
            this.lo = false;
            if (response.Durum === 'OK') {
              this.Kategoriler = response.Liste
            } else {
              this.$message.error(response.Mesaj);
              this.hata = response.Hata;
            }
          });
      }
    },
    ModalKapat() {
      this.$emit('ModalOlayi', false)
    },
    Submit() {
      this.$refs['Form'].validate((valid) => {
        if (valid) {
          this.lo = true;
          if (this.Form.id) {

            // DÜZENLE
            this.Form.Tahakkuklar = this.data;
            this.$store.dispatch("Put", {...this.Form, path: 'icra/dosya/'})
              .then(response => {
                this.lo = false;
                if (response.Durum == "OK") {
                  this.ModalKapat();
                  this.$message.success(response.Mesaj);
                  this.hata = response.Hata;
                } else {
                  this.$message.error(response.Mesaj);
                  this.hata = response.Hata;
                }
              })
          } else {
            if (this.Form.Avukat_id) {
              this.Ekle();
            } else {
              this.$confirm('Aidatım ile icra işleminde anlaşmalı Avukatlık Ofisi sizinle iletişime geçip gerekli onay ve bilgilendirmeden sonra dosya açılışını sağlayacaklardır.<hr><small> Bu kapsamda Avukat Ofisine bu dosyanın ve sizin bilgileriniz paylaşılacaktır.</small>', 'İcra Onayı', {
                confirmButtonText: 'Onayla ve Dosya Oluştur',
                cancelButtonText: 'İptal',
                dangerouslyUseHTMLString: true
              }).then(() => {
                this.Ekle();
              }).catch(() => {
                this.lo = false;
                this.$message({
                  type: 'info',
                  message: 'İptal Edildi'
                });
              });
            }
          }
        }

      });
    },
    Ekle() {
      // EKLE
      this.Form.Tahakkuklar = this.data;
      this.$store.dispatch("Post", {...this.Form, path: 'icra/dosya/'})
        .then(response => {
          this.lo = false;
          if (response.Durum == "OK") {
            this.ModalKapat();
            this.$message.success(response.Mesaj);
            this.hata = response.Hata;
          } else {
            this.$message.error(response.Mesaj);
            this.hata = response.Hata;
          }
        })
    }
  },
  created() {
    this.SayfaYukle();
    var Gun = new Date();
    this.Form.iTarih = Gun;
    if (this.Bilgi) {
      this.Aidatim = this.Bilgi.Aidatim;
    }

  }
}
</script>

<style scoped>

</style>





// WEBPACK FOOTER //
// src/components/Pack/Icra/IcraDosyaOlustur.vue